<template>
    <div ref="objectBlockWrapper" class="objectBlockWrapper">
        <div ref="objectBlockParent" :id="uniqueId" class="objectBlock">
            <div v-if="isDev" class="editor-item editor-pox-y"><span class="editor-text">{{posX}}</span></div>
            <div v-if="isDev" class="editor-item editor-pos-x"><span class="editor-text">{{posY}}</span></div>
            <img ref="objectBlockImage" v-if="isImage" v-bind:src="dataSource" :alt="dataSource"/>
        </div>
    </div>
</template>

<script>
    /* eslint-disable
      no-console,
      no-unused-vars
    */
    import uniqueId from 'lodash-es/uniqueId'
    import { TimelineMax , TweenMax, CSSPlugin, ScrollToPlugin, Draggable, Elastic } from 'gsap/all'
    export default {
        name: "ObjectBlock",
        props : {
            //dimension and position
            id: {
                type : String,
                default : null,
            },
            width : Number,
            height : Number,
            zIndex : Number,
            positionX : Number,
            positionY : Number,
            //type of object image , video , stream
            type : String,
            //state of object movable or not
            locked : Boolean,
            //custom styles
            customCss : String,
            //custom class name
            customClassName : Array,
            //data source eg src // url // path
            dataSource : {
                type : String,
                default : null
            },
            imgSource : {
                type : String,
                default : null
            },
            //state

        },
        data() {
            return {
                isMounted:false,
                dragHandle : null,
                posX : 0,
                posY : 0,
                isDev : true,
            }
        },
        mounted () {
            let vmThis = this;
            let ref = this.$refs["objectBlockParent"];
            let parentId = "#" + ref.id;
            this.dragHandle = Draggable.create(parentId)[0];
            this.isMounted = true;
            if(this.dragHandle !== null){
                this.dragHandle.addEventListener("drag",function(){
                    vmThis.posX = this.getBoundingClientRect().left;
                    vmThis.posY = this.getBoundingClientRect().top;
                    //console.log(this.posX);
                });
            }
        },
        methods : {

        },
        watch: {
            posX: {
                // the callback will be called immediately after the start of the observation
                immediate: true,
                handler(val, oldVal) {

                }
            }
        },
        computed : {
            currentPosX(){
                if(!this.isMounted) {
                    return 0;
                }else {
                    return this.posX;
                }
            },
            currentPosY(){
                return this.posY;
            },
            uniqueId () {
                return uniqueId('object-block-');
            },
            isImage : function () {
                return this.type === "Image";
            }
        }
    }

</script>

<style lang="scss" scoped>
    .editor-item {
        position: absolute;
    }

    .editor-pos-x  {
        background-color: white;
        width: 80px;
        height: 30px;
        top:0;
        right:20px;
    }

    .editor-pox-y {
        background-color: white;
        width: 80px;
        height: 30px;
        top:35px;
        right:20px;
    }
    .editor-text {
        display: block;
        line-height: 20px;
        text-align: right;
        padding: 5px;
    }
    .objectBlockParent {
        position: relative;
    }
    .objectBlock {
        display: inline-block;
    }
</style>